import { render, staticRenderFns } from "./MiEmpresa.vue?vue&type=template&id=abe5c5f8&"
import script from "./MiEmpresa.vue?vue&type=script&lang=js&"
export * from "./MiEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports